import { render, staticRenderFns } from "./PersonalizationEditor.vue?vue&type=template&id=0f913b21&scoped=true&"
import script from "./PersonalizationEditor.vue?vue&type=script&lang=js&"
export * from "./PersonalizationEditor.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizationEditor.vue?vue&type=style&index=0&id=0f913b21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f913b21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VContainer,VDivider,VIcon,VOverlay,VProgressCircular,VSpacer,VSubheader,VToolbar,VToolbarTitle,VTooltip,VTreeview})
